import { createContext, useContext, useEffect, useState, useCallback } from "react";

const KEY = "ab_passport_v1";
const PassportContext = createContext(null);

export const PassportProvider = ({ children }) => {
  const [stamped, setStamped] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(stamped));
  }, [stamped]);

  const isStamped = useCallback((code) => stamped.includes(code), [stamped]);

  const toggleStamp = useCallback((code) => {
    setStamped((s) => (s.includes(code) ? s.filter((c) => c !== code) : [...s, code]));
  }, []);

  const stampAll = useCallback((codes) => setStamped(codes), []);
  const resetStamps = useCallback(() => setStamped([]), []);

  return (
    <PassportContext.Provider
      value={{ stamped, count: stamped.length, isStamped, toggleStamp, stampAll, resetStamps }}
    >
      {children}
    </PassportContext.Provider>
  );
};

export const usePassport = () => {
  const ctx = useContext(PassportContext);
  if (!ctx) throw new Error("usePassport must be used within PassportProvider");
  return ctx;
};
